<ng-container *ngIf="!answer?.extra">
  <p *ngIf="!answer?.subquestion_label" class="mb-0">{{ answer.value }}</p>
</ng-container>

<ng-container *ngIf="answer?.extra">
  <p>{{answer?.value}}/{{answer?.extra.stars}}</p>
</ng-container>
